<script lang="ts">
	import { IconButton } from '@Shelly/shelly-design-system';
	import { profile_data } from 'src/stores/account/user';
	import { save_profile } from '../../helpers/profile_helpers';

	const updateHomeData = () => {
		save_profile('alexaIntegrationPrompt', {
			seen: false,
		});

		profile_data.set({
			...$profile_data,
			alexaIntegrationPrompt: {
				seen: false,
			},
		});
	};
</script>

<IconButton class="mr-s" icon="fa-brands fa-amazon" on:click={updateHomeData}
	>Reset Alexa Pop-up</IconButton
>
